// extracted by mini-css-extract-plugin
export default {"mCard":"tD-z","image":"uD-z","imageNoBackground":"vD-z","imageHasCategory":"wD-z","fullWidth":"xD-z"};